import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/holidays/holidays.component';
@Component({
  selector: 'app-add-holidays-dialog',
  templateUrl: './add-holidays-dialog.component.html',
  styleUrls: ['./add-holidays-dialog.component.scss'],
  standalone: false,  // NOSONAR
})
export class AddHolidaysDialogComponent implements OnInit {
  description;
  startDate;
  endDate;
  taskID = "Auto assigned";
  action;
  enableError: boolean = false;
  errormsg;
  enableEndDate;
  constructor(public dialogRef: MatDialogRef<AddHolidaysDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {
    if (this.startDate) {
      this.enableEndDate = true;
    }
  }
  ngOnInit(): void { // NOSONAR
    //  do something 
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    if (!this.description || !this.startDate || !this.endDate || this.description.trim().length == 0) {  // NOSONAR
      this.enableError = true;
      this.errormsg = 'Please fill in the required fields!'
    }
    else if (this.endDate < this.startDate) {
      this.enableError = true;
      this.errormsg = 'End Date must be on/after Start Date!'
    }
    else {
      this.action = this.dataStore.performAction;
      console.info("start date", this.startDate, "enddate", this.endDate);
      const arr = this.startDate.split("-");
      this.startDate = arr[1] + "-" + arr[2] + "-" + arr[0];
      console.info("start date aftr", this.startDate);
      const arr2 = this.endDate.split("-");
      this.endDate = arr2[1] + "-" + arr2[2] + "-" + arr2[0];
      this.dialogRef.close({ event: this.action, data1: this.description, data2: this.startDate, data3: this.endDate });
    }
  }
}